'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var debounce = exports.debounce = require('lodash.debounce');
var defer = exports.defer = require('lodash.defer');
var throttle = exports.throttle = require('lodash.throttle');

var noop = exports.noop = function noop() {};

exports.default = {
  debounce: debounce,
  defer: defer,
  noop: noop,
  throttle: throttle
};